import { whatsappLink, whatsappMessages } from '@/lib/site-data'
import {MessageCircleDashed as MessageCircle} from 'lucide-react'

function WhatsAppFloatButton() {
  return (
    <a
      href={whatsappLink(whatsappMessages.finalCta)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp com a Muita Mídia"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3.5 text-white shadow-lg shadow-black/20 transition-transform hover:scale-105 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366]/40 sm:bottom-6 sm:right-6"
    >
      <MessageCircle className="h-6 w-6 shrink-0" fill="white" strokeWidth={0} />
      <span className="hidden text-sm font-semibold sm:inline">Fale no WhatsApp</span>
    </a>
  )
}

export default WhatsAppFloatButton
